import type { ComboboxOptions } from "@shared-kernel/primary/shared/combobox/combobox";
import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import CreatableReactSelect from "react-select/creatable";

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any, any>;
  formName: string;
  options: ComboboxOptions[];
  styleOptions?: { menu: { width: string } };
  allowCreate?: boolean;
}

export const CreatableSelect = ({ control, formName, options, styleOptions, allowCreate = true }: Props) => {
  const menuStyle = { ...styleOptions?.menu };
  const isDarkMode = typeof window !== "undefined" && document.documentElement.classList.contains("dark");

  return (
    <Controller
      name={formName}
      control={control}
      render={({ field }) => {
        const { value, ...rest } = field;
        const val = value?.value ? value : null;
        return (
          <CreatableReactSelect
            {...rest}
            isClearable
            isSearchable={true}
            options={options}
            value={val}
            placeholder="Sélectionner..."
            formatCreateLabel={input => `Ajouter ${input}`}
            styles={{
              menu: base => ({ ...base, ...menuStyle, backgroundColor: isDarkMode ? "hsl(var(--popover))" : base.backgroundColor }),
              control: base => ({
                ...base,
                backgroundColor: isDarkMode ? "hsl(var(--background))" : base.backgroundColor,
                borderColor: isDarkMode ? "hsl(var(--input))" : base.borderColor,
              }),
              singleValue: base => ({ ...base, color: isDarkMode ? "hsl(var(--foreground))" : base.color }),
              input: base => ({ ...base, color: isDarkMode ? "hsl(var(--foreground))" : base.color }),
              placeholder: base => ({ ...base, color: isDarkMode ? "hsl(var(--muted-foreground))" : base.color }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused
                  ? isDarkMode
                    ? "hsl(var(--accent))"
                    : base.backgroundColor
                  : isDarkMode
                    ? "hsl(var(--popover))"
                    : base.backgroundColor,
                color: isDarkMode ? "hsl(var(--foreground))" : base.color,
              }),
            }}
            isValidNewOption={() => allowCreate}
          />
        );
      }}
    />
  );
};
